<div class="main-container" [ngClass]="{ large: !thumbnail, small: thumbnail }">
  <div class="avatar-container">
    @if (shouldShowAvatar() && !darkened) {
      <img [src]="getImageUrl()" alt="" />
    }
    @if (shouldShowAvatar() && darkened) {
      <img [src]="getDarkened()" alt="" />
    }
    @if (shouldShowAvatar()) {
      <img class="prefetched-darkened-image" [src]="getDarkened()" alt="" />
    }
    @if (!shouldShowAvatar() && !noDefaultAvatar && !selected) {
      <img [src]="getDefaultImageUrl()" alt="" />
    }
    @if (selected) {
      <mat-icon color="primary" class="md-40" data-testid="person-selected"
        >check_circle</mat-icon
      >
    }
    @if (!shouldShowAvatar() && noDefaultAvatar) {
      <div
        [ngClass]="{ 'avatar-large': !thumbnail, 'avatar-small': thumbnail }"
      ></div>
    }
  </div>
</div>
